export const DefaultTicker: string = 'SPY'
